import { render, staticRenderFns } from "./EditarSolicitud.vue?vue&type=template&id=63d126b3&"
import script from "./EditarSolicitud.vue?vue&type=script&lang=ts&"
export * from "./EditarSolicitud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports